import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Pythonsidebar';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";

function Pwhile(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  


return(
     <div>
<Sides/>
<Helmet>
 
  <title>Learn Free Python While Loop Beginners Tutorials CodeExampler</title>
<meta name="description" content="Learn Free Python While Loop Beginners Tutorials CodeExampler This condition will be given and the body of the loop will be executed until the given condition is false" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,While looping in python,Python while loop,While loops in python,How to use while loops in python,Python while loop example,Python for while loop,Python while loop range,python do while loop example,do while loop in python" />
<link rel="canonical" href="https://www.codeexampler.com/python-while" />
</Helmet>
<div className='lg:pl-56'>

    <h1 className="m-4 mh1">While looping in Python</h1>

    <div className="first">
        <a href="/python-looping">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-for-loop">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>


    <h2 className="mt-4 mh2">Python while loop:</h2>
    <p className="mt-4 para">A python while loop will give this condition, and the body of the loop will execute until the given condition is false</p>
    <h3 className="mt-4 ">How to use while loops in python Syntax:</h3>
    
   

       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-7">while</span>
                <span className="qwerty-6"> condition</span>
                <span className="qwerty-1">:</span>
            {"\n"}
                <span className="qwerty-3">   statement</span>
            {"\n"}
                <span className="qwerty-4">   body</span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>  


<h2 className="mt-4 mh2">Python while loop Example:</h2>


<h2 className='headings'>Q-Loop starts from 1 to 5 with addition While loops in Python?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-4">a</span>
                <span className="qwerty-1"> = </span>
                <span className="qwerty-2">1</span>
            {"\n"}
                <span className="qwerty-7">while</span>
                <span className="qwerty-4"> a</span>
                <span className="qwerty">&#60;=</span>
                <span className="qwerty-8">5</span>
                <span className="qwerty-1">:</span>
            {"\n"}
                <span className="qwerty-3">   print</span>
                <span className="qwerty-1">(</span>
                <span className="qwerty-4">a</span>
                <span className="qwerty-1">)</span>
            {"\n"}
                <span className="qwerty-4">   a</span>
                <span className="qwerty-1">=</span>
                <span className="qwerty-4">a</span>
                <span className="qwerty">+</span>
                <span className="qwerty-2">1</span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>          
        <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"100vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty-3">1</span>
                         {"\n"} 
                         <span className="qwerty-3">2</span>
                         {"\n"} 
                         <span className="qwerty-3">3</span>
                         {"\n"} 
                         <span className="qwerty-3">4</span>
                         {"\n"} 
                         <span className="qwerty-3">5</span>
                         {"\n"} 
                              {"\n"}      
               </code>
                 </pre>
                 </div>





<h2 className='headings'>Q-Subtract in Python while loop example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">10</span>
             {"\n"}
                 <span className="qwerty-7">while</span>
                 <span className="qwerty-4"> b</span>
                 <span className="qwerty">&#62;=</span>
                 <span className="qwerty-8">0</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-3">   print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-4">   b</span>
                 <span className="qwerty-1">=</span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty">-</span>
                 <span className="qwerty-2">1</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                      {"\n"}
                          <span className="qwerty-3">10</span>
                          {"\n"} 
                          <span className="qwerty-3">9</span>
                          {"\n"} 
                          <span className="qwerty-3">8</span>
                          {"\n"} 
                          <span className="qwerty-3">7</span>
                          {"\n"} 
                          <span className="qwerty-3">6</span>
                          {"\n"} 
                          <span className="qwerty-3">5</span>
                          {"\n"} 
                          <span className="qwerty-3">4</span>
                          {"\n"} 
                          <span className="qwerty-3">3</span>
                          {"\n"} 
                          <span className="qwerty-3">2</span>
                          {"\n"} 
                          <span className="qwerty-3">1</span>
                          {"\n"} 
                          <span className="qwerty-3">0</span>
                          {"\n"} 
                               {"\n"}      
                </code>
                  </pre>
                  </div>


<h2 className="mt-4 mh2">Reverse in While looping in python:</h2>



<h2 className='headings'>Q-Write a program to input an integer number and print it in reverse?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">256</span>
             {"\n"}
                 <span className="qwerty-8">rev</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">0</span>
             {"\n"}
                 <span className="qwerty-7">while</span>
                 <span className="qwerty-4"> a</span>
                 <span className="qwerty">&#62;</span>
                 <span className="qwerty-8">0</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-8">   bal</span>
                 <span className="qwerty-1">=</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">%</span>
                 <span className="qwerty-2">10</span>
             {"\n"}
                 <span className="qwerty-8">   rev</span>
                 <span className="qwerty-1">=</span>
                 <span className="qwerty-8">rev</span>
                 <span className="qwerty">*</span>
                 <span className="qwerty-2">10</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-8">bal</span>
             {"\n"}
                 <span className="qwerty-4">   a</span>
                 <span className="qwerty-1">=</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">//</span>
                 <span className="qwerty-2">10</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">The reverse number is=</span>
                 <span className="qwerty-1">",</span>
                 <span className="qwerty-4">rev</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
             {"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                      {"\n"}
                          <span className="qwerty-2">The reverse number is= </span>
                          <span className="qwerty-3">652</span>
                          {"\n"} 
                               {"\n"}      
                </code>
                  </pre>
                  </div>



<h2 className='headings'>Q-Write a program to found out the sum of digits of integer no in Python while loop example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">2560</span>
             {"\n"}
                 <span className="qwerty-8">sum</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">0</span>
             {"\n"}
                 <span className="qwerty-7">while</span>
                 <span className="qwerty-4"> a</span>
                 <span className="qwerty">&#62;</span>
                 <span className="qwerty-8">0</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-8">   sum</span>
                 <span className="qwerty-1">=</span>
                 <span className="qwerty-4">sum</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-4">a</span>
             {"\n"}
                 <span className="qwerty-4">   a</span>
                 <span className="qwerty-1">=</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">//</span>
                 <span className="qwerty-2">10</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">Sum of digit=</span>
                 <span className="qwerty-1">",</span>
                 <span className="qwerty-4">sum</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
             {"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                      {"\n"}
                      <span className="qwerty-2">Sum of digit= </span>
                          <span className="qwerty-3">2843</span>
                          {"\n"} 
                               {"\n"}      
                </code>
                  </pre>
                  </div>
          

<h3 className="mt-4 mh3">Sum of Digit in Python While:</h3>



<h2 className='headings'>Q-Write a program to input found out the sum of digits of integer no in Python while loop example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
             
             <span className="qwerty-4">n</span>
                  <span className="qwerty-9"> = </span>
                  <span className="qwerty-6">int</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-8">input</span>
                  <span className="qwerty-6">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">Enter a no:</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-6">)</span>
                  <span className="qwerty-1">)</span>
              {"\n"}
                 <span className="qwerty-8">sum</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">0</span>
             {"\n"}
                 <span className="qwerty-7">while</span>
                 <span className="qwerty-4"> n</span>
                 <span className="qwerty">&#62;</span>
                 <span className="qwerty-8">0</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-8">   sum</span>
                 <span className="qwerty-1">=</span>
                 <span className="qwerty-8">sum</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-4">n</span>
                 <span className="qwerty">%</span>
                 <span className="qwerty-2">10</span>
             {"\n"}
                 <span className="qwerty-4">   n</span>
                 <span className="qwerty-1">=</span>
                 <span className="qwerty-4">n</span>
                 <span className="qwerty">//</span>
                 <span className="qwerty-2">10</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">Sum of Digit=</span>
                 <span className="qwerty-5">%d</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-4">%sum</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
             {"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                      {"\n"}
                          <span className="qwerty-8">Enter a no </span>
                      {"\n"}
                          <span className="qwerty-4">3546</span>
                      {"\n"}
                          <span className="qwerty-3">Sum of Digit= </span>
                          <span className="qwerty-2">17</span>
                          {"\n"} 
                               {"\n"}      
                </code>
                  </pre>
                  </div>

<p className="mt-4 para">If you don't know about input in Python so check on <a href="https://www.codeexampler.com/python-function">max function in python</a> with Lot Of Examples.</p>

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/python-looping">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-for-loop">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Pwhile;